import styled from 'styled-components';

export const CloseModalButton = styled.button`
  position: fixed;
  top: 5%;
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 100%;
  background: none;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 22px;
  cursor: pointer;
  :hover {
    color: #3682F9;
  }
`